module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-journey/view"
    }
  }, [_vm._v("View User Journeys")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.currentJourneyData.name))])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "journey-settings-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.currentJourneyData.name))]), _vm._v(" "), _c('div', {
    staticClass: "journey-settings-meta"
  }, [_c('span', {
    class: ['label', _vm.currentJourneyData.deployed ? 'label-success' : 'label-default']
  }, [_vm._v("\n              " + _vm._s(_vm.currentJourneyData.deployed ? 'Deployed' : 'Not deployed') + "\n            ")]), _vm._v(" "), (_vm.currentJourneyData.releasedDate) ? _c('span', [_vm._v("Last released: " + _vm._s(_vm.formatDate(_vm.currentJourneyData.releasedDate)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "journey-settings-tabs"
  }, [_c('button', {
    staticClass: "journey-settings-tab",
    class: {
      'journey-settings-tab--active': _vm.activeTab === 'funnel'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'funnel'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Funnel Stage Mapping\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "journey-settings-tab",
    class: {
      'journey-settings-tab--active': _vm.activeTab === 'nudge'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'nudge'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" Nudge Settings\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "journey-settings-tab",
    class: {
      'journey-settings-tab--active': _vm.activeTab === 'metadata'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'metadata'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Journey Metadata\n          ")])]), _vm._v(" "), (_vm.activeTab === 'funnel') ? _c('div', {
    staticClass: "journey-settings-tab-content"
  }, [_c('funnel-stage-mapping', {
    attrs: {
      "journey-name": _vm.currentJourneyData.name
    },
    model: {
      value: (_vm.funnelStageMapping),
      callback: function($$v) {
        _vm.funnelStageMapping = $$v
      },
      expression: "funnelStageMapping"
    }
  })], 1) : _c('div', {
    staticClass: "journey-settings-tab-content journey-settings-tab-content--placeholder"
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-2x"
  }), _vm._v(" "), _c('div', [_vm._v("Coming soon.")])]), _vm._v(" "), _c('div', {
    staticClass: "journey-settings-footer"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Changes apply to all future campaigns for this journey. Active campaigns are not affected.")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.discardAndGoBack
    }
  }, [_vm._v("Discard & go back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n              " + _vm._s(_vm.saving ? 'Saving...' : 'Save changes') + "\n            ")])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n      USER JOURNEY\n      "), _c('small', [_vm._v("Journey Detail")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-20b2728a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/JourneySettings.vue
// module id = Ughk
// module chunks = 1